import React from 'react'
import "./Testimonial"
const Testimonial = () => {
  return (
    <div>
      Testimonial
    </div>
  )
}

export default Testimonial
